import { isArray } from 'lodash';

import { Region } from 'components/notifications/Settings/LocationDropdown';
import { ICountryFlagProps } from 'types/shared';
import { ITopicFilterState } from 'components/TopicFilters/shared';

const getLocationNames = ({
  allCountries,
  allExCountries,
  allRegions,
  filters,
}: {
  allCountries: ICountryFlagProps[];
  allExCountries: ICountryFlagProps[];
  allRegions: Region[];
  filters: ITopicFilterState;
}): string => {
  if (
    filters &&
    Object.values(filters).filter((value: string | undefined) => !!value)
      .length === 0
  )
    return '';

  const filtersTitles = Object.keys(filters)
    .reduce((total: string[], filter: any) => {
      let filterValue;
      if ((filters as any)[filter] === undefined) return [...total, ''];

      if (filter === 'country') {
        const all =
          isArray((filters as any)[filter]) &&
          (filters as any)[filter][0].includes('EX')
            ? allExCountries
            : (filters as any)[filter].includes('EX')
            ? allExCountries
            : allCountries;

        if (isArray((filters as any)[filter])) {
          filterValue = (filters as any)[filter].map((current: string) => {
            const currentCountry = all.find(
              (country: ICountryFlagProps) => country?.id === current
            )?.displayName;
            return (filters as any)[filter].includes('EX')
              ? `EX ${currentCountry}`
              : currentCountry;
          });
        } else {
          const currentCountry = all.find(
            (country: ICountryFlagProps) =>
              country?.id === (filters as any)[filter]
          )?.displayName;
          filterValue = (filters as any)[filter].includes('EX')
            ? `EX ${currentCountry}`
            : currentCountry;
        }
      }
      if (filter === 'region') {
        if (isArray((filters as any)[filter])) {
          filterValue = (filters as any)[filter].map((current: string) => {
            return allRegions.find((region: Region) => region?.id === current)
              ?.displayName;
          });
        } else {
          const currentRegion = allRegions.find(
            (region: Region) => region.id === (filters as any)[filter]
          );
          filterValue = currentRegion?.displayName;
        }
      }
      if (filter === 'customRegion') {
        filterValue = (filters as any)[filter];
      }

      return isArray(filterValue)
        ? [...total, ...filterValue]
        : [...total, filterValue];
    }, [])
    .filter((value: string) => !!value)
    .map((filter: string) => `${filter[0].toUpperCase()}${filter.substring(1)}`)
    .sort((a: string, b: string) =>
      a.toLowerCase() > b.toLowerCase() ? 1 : -1
    )
    .join(', ');

  return filtersTitles;
};

export default getLocationNames;
